import { useIntl } from 'react-intl';
import { TaptapList } from 'sonata-react-components';

import type { CampaignFamilyEnum } from 'sonata-static-storage/lib/schemas/campaign/campaign.schema';
import type { AdCreativesVisibleColumns } from './AdCreatives.helper';

type Props = {
  id: string;
  type: CampaignFamilyEnum;
  visibleColumns: AdCreativesVisibleColumns;
  withAutoDistribution?: boolean;
  toggleAutoDistribution?: () => void;
};

export default function AdCreativesColumns({
  id,
  type,
  visibleColumns,
  withAutoDistribution,
  toggleAutoDistribution
}: Props) {
  const { formatMessage } = useIntl();

  return (
    <TaptapList.ColumnsBar>
      <TaptapList.ColumnsBar.Column
        className="adCreatives__tableColumnsBarColumnTitle"
        description={formatMessage({
          defaultMessage: 'Creative',
          id: 'creatives.adCreatives.table.columns.creative'
        })}
        id={`creative-name-${id}`}
        key="name"
      />
      <TaptapList.ColumnsBar.Column
        className="adCreatives__tableColumnsBarColumnDuration"
        description={formatMessage({
          defaultMessage: 'Duration',
          id: 'creatives.adCreatives.table.columns.duration'
        })}
        id={`creative-duration-${id}`}
        key="duration"
      />
      {visibleColumns.behavior && (
        <TaptapList.ColumnsBar.Column
          className="adCreatives__tableColumnsBarColumnBehavior"
          description={formatMessage({
            defaultMessage: 'Behavior',
            id: 'creatives.adCreatives.table.columns.behavior'
          })}
          id={`creative-behavior-${id}`}
          key="behavior"
        />
      )}
      {visibleColumns.qr && (
        <TaptapList.ColumnsBar.Column
          className="adCreatives__tableColumnsBarColumnQr"
          description={formatMessage({
            defaultMessage: 'QR',
            id: 'common.qr'
          })}
          id={`creative-qr-${id}`}
          key="qr"
        />
      )}
      {visibleColumns.adTypeScreens && (
        <TaptapList.ColumnsBar.Column
          className="adCreatives__tableColumnsBarColumnAdTypeScreens"
          description={formatMessage({
            defaultMessage: 'Ad Type/Screens',
            id: 'creatives.adCreatives.table.columns.adTypeScreens'
          })}
          id={`creative-adTypeScreens-${id}`}
          key="adTypeScreens"
        />
      )}
      <TaptapList.ColumnsBar.Column
        className="adCreatives__tableColumnsBarColumnGroup"
        description={
          type === 'dooh'
            ? formatMessage({
                defaultMessage: 'Screen Group',
                id: 'creatives.adCreatives.table.columns.screenGroups'
              })
            : formatMessage({
                defaultMessage: 'Location Group',
                id: 'creatives.adCreatives.table.columns.locationGroups'
              })
        }
        id={`creative-group-${id}`}
        key="group"
      />
      {visibleColumns.distribution && (
        <TaptapList.ColumnsBar.Column
          className="adCreatives__tableColumnsBarColumnDistribution"
          description={formatMessage({
            defaultMessage: 'Distribution',
            id: 'creatives.adCreatives.table.columns.distribution'
          })}
          icon={withAutoDistribution ? 'fa-regular fa-lock' : 'fa-regular fa-lock-open'}
          id={`creative-distribution-${id}`}
          key="distribution"
          onIconClick={toggleAutoDistribution}
        />
      )}
      {visibleColumns.adPrice && (
        <TaptapList.ColumnsBar.Column
          className="adCreatives__tableColumnsBarColumnAdPrice"
          description={formatMessage({
            defaultMessage: 'Ad Price',
            id: 'creatives.adCreatives.table.columns.adPrice'
          })}
          id={`creative-adPrice-${id}`}
          key="adPrice"
        />
      )}
      <TaptapList.ColumnsBar.Column
        className="adCreatives__tableColumnsBarColumnStatus"
        description={formatMessage({
          defaultMessage: 'AdExchanges Status',
          id: 'creatives.adCreatives.table.columns.adExchangeStatus'
        })}
        id={`creative-status-${id}`}
        key="status"
      />
    </TaptapList.ColumnsBar>
  );
}
